import React from "react";
import { Box, Typography } from "@mui/material";

const PreviewStats = ({ data }) => (
  <Box display="flex" gap={3}>
    {data.items.map((s, i) => (
      <Box key={i} textAlign="center">
        <Typography variant="body1" fontWeight={700} sx={{ color: "#3b82f6" }}>
          {s.value}
        </Typography>
        <Typography variant="caption" color="text.secondary">
          {s.label}
        </Typography>
      </Box>
    ))}
  </Box>
);

export default PreviewStats;